import React, { FC, HTMLAttributes } from 'react';

export interface TabsProps extends HTMLAttributes<HTMLDivElement> {}

export const Tabs: FC<TabsProps> = ({ children, className }) => {
  return <div className={`tabs ${className}`}>{children}</div>;
};
